import React from 'react';
import './Legal.css';

function Privacy() {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="effective-date">Effective Date: January 14, 2025</p>

        <section className="legal-section">
          <h2>Data Collection and Use</h2>
          <p>We respect your privacy and are committed to protecting your personal information. Any information you provide to us will be used solely to deliver our services, improve our offerings, and communicate with you.</p>
        </section>

        <section className="legal-section">
          <h2>Information Sharing</h2>
          <p>We do not share, sell, or rent your personal or sensitive information to any third parties. Your data is kept strictly confidential and is only accessible to authorized personnel for legitimate business purposes.</p>
        </section>

        <section className="legal-section">
          <h2>Security</h2>
          <p>We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, or disclosure. While we strive to ensure the security of your data, no system is entirely foolproof.</p>
        </section>

        <section className="legal-section">
          <h2>Your Rights</h2>
          <ul>
            <li>You have the right to access the information we collect about you.</li>
            <li>You may request corrections or deletions of your personal data at any time.</li>
            <li>To exercise these rights, please contact us on Discord at <a href="https://discord.gg/riftone" target="_blank" rel="noopener noreferrer">discord.gg/riftone</a></li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Payment Processing</h2>
          <p>All payment processing is handled securely through our third-party payment processor. We do not store your credit card or payment information on our servers.</p>
        </section>

        <section className="legal-section">
          <h2>Changes to This Policy</h2>
          <p>We reserve the right to update this Privacy Policy as necessary. Any changes will be posted on this page with the updated effective date. We encourage you to review this policy periodically.</p>
        </section>

        <section className="legal-section">
          <h2>Contact</h2>
          <p>For any questions or concerns regarding this Privacy Policy, please contact us on Discord at <a href="https://discord.gg/riftone" target="_blank" rel="noopener noreferrer">discord.gg/riftone</a></p>
        </section>
      </div>
    </div>
  );
}

export default Privacy;